import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";

export class LeadForm extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: (
			<span className="text-uppercase">
				Kérd részletes
				<br /> eredményeidet email-ben!
			</span>
		),
		button: "Eredmény küldése",
	};

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
